import { NgModule } from "@angular/core";
import { AlertSharedModule } from "@app2/alert/alert-shared/alert-shared.module";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@app2/shared/shared.module";
import { CommonModule } from "@angular/common";
import { TicketSharedModule } from "@app2/ticket/shared/ticket-shared.module";
import { AlertTicketActionNotificationComponent } from "@app2/alert/alert-ticket-action-notification.component";
import { SearchSharedModule } from "@app2/search/search-shared/search-shared.module";
import { isLoggedInGuard } from "@app2/navigation/is-logged-in.guard";
import { permissionsRequiredGuard } from "@app2/navigation/permissions-required.guard";
import { AlertInboxPageComponent } from "@app2/alert/alert-inbox/alert-inbox-page.component";
import { RouterModule, Routes } from "@angular/router";
import {
    ALERT_INBOX_DROPDOWN_FILTER_TOKEN,
    ALERT_INBOX_GROUPS_TOKEN,
    ALERT_INBOX_MODES_TOKEN
} from "@app2/alert/alert-inbox/injection-tokens";
import { fraudDropdownFilterOptions, fraudModeOptions, securityAlertGroups } from "@app2/alert/alert-inbox/constants";

const routes: Routes = [
    {
        path: "inbox",
        component: AlertInboxPageComponent,
        canActivate: [isLoggedInGuard, permissionsRequiredGuard],
        data: {
            permissionsRequired: "ALERT_INBOX_VIEW",
        },
        title: "ALERTS",
    },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        AlertSharedModule,
        TicketSharedModule,
        SearchSharedModule,
        RouterModule.forChild(routes),
    ],
    declarations: [
        AlertTicketActionNotificationComponent,
    ],
    providers: [
        { provide: ALERT_INBOX_GROUPS_TOKEN, useValue: securityAlertGroups },
        { provide: ALERT_INBOX_DROPDOWN_FILTER_TOKEN, useValue: fraudDropdownFilterOptions },
        { provide: ALERT_INBOX_MODES_TOKEN, useValue: fraudModeOptions },
    ],
})
export class AlertModule {
    constructor() {
    }
}
